// export default IncidentRequest;
import React from "react";
import FurtherInvestigationList from "./FurtherInvestigationList";

type Props = {
  crimeReferenceNumber?: string;
  incidentRegistrationNumber?: string;
};

const FurtherInvestigationTab: React.FC<Props> = ({
  crimeReferenceNumber,
  incidentRegistrationNumber,
}) => {
  return (
    <FurtherInvestigationList
      crimeReferenceNumber={crimeReferenceNumber}
      incidentRegistrationNumber={incidentRegistrationNumber}
    />
  );
};

export default FurtherInvestigationTab;
